import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  detailContainer: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    gap: "20px",
  },
  container: {
    paddingBottom: "50px",
  },
  warningContainer: {
    display: "flex",
    alignItems: "center",
    paddingTop: "10px",
    paddingBottom: "15px",
    marginBottom: "15px",
    gap: "10px",
    color: "#D67200",
  },
  warningMsg: {
    margin: 0,
    fontWeight: 500,
    fontSize: "14px",
  },
  header: {
    margin: "22px 0 !important",
    fontSize: "14px",
    fontWeight: "500",
    color: "#7A7A7A",
  },
}));
